import type { TFunction } from 'i18next';

/**
 * The label keys the policy detail export names (SDD-020 §8.3, prompt 28 Decision 6). The
 * service publishes the same list in api/exports/; a unit test fails when they differ, and the
 * typed `t` fails the build when a key has no text.
 */
export const POLICY_EXPORT_LABEL_KEYS = [
  'column.field',
  'column.timeline.operation',
  'column.timeline.recordedAt',
  'column.timeline.status',
  'column.timeline.tarifVersionErn',
  'column.timeline.validFrom',
  'column.timeline.validTo',
  'column.value',
  'field.code',
  'field.data',
  'field.insuredPerson',
  'field.originLeadCode',
  'field.parentPolicyCode',
  'field.partners',
  'field.policyholder',
  'field.premiumAmount',
  'field.premiumMonthly',
  'field.premiumPeriod',
  'field.status',
  'field.tarifVersionErn',
  'field.validFrom',
  'field.validTo',
  'sheet.overview',
  'sheet.timeline',
] as const;

export type PolicyExportLabelKey = (typeof POLICY_EXPORT_LABEL_KEYS)[number];

/** The `labels` map of the detail export, in the reader's language. */
export function buildPolicyExportLabels(t: TFunction<'insurance'>): Record<string, string> {
  return Object.fromEntries(
    POLICY_EXPORT_LABEL_KEYS.map((key) => [key, t(`exportLabels.policy.${key}`)]),
  );
}
